import { PARC_ACT, PARC_DEL, PARC_DET, PARC_ENABLE, PARC_LIST, PARC_SAVE } from "../actions/action-types";
import { initialStateDatasArray, initialSTateDatasData, initialStateNext } from "../helpers";

// Liste des parcs
export function ListParcReducer(state = initialStateDatasArray, action) {
    switch(action.type) {
        case PARC_LIST:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Liste des parcs actifs
export function ListParcActReducer(state = initialStateDatasArray, action) {
    switch (action.type) {
        case PARC_ACT:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Détails d'un parc
export function DetailsParcReducer(state = initialSTateDatasData, action) {
    switch(action.type) {
        case PARC_DET:
            return {
                alert: action.payload.alert,
                datas: action.payload.datas
            }
        default:
            return state;
    }
}

// Sauvegarde d'un parc
export function SaveParcReducer(state = initialStateNext, action) {
    switch(action.type) {
        case PARC_SAVE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Suppression d'un parc
export function DeleteParcReducer(state = initialStateNext, action) {
    switch(action.type) {
        case PARC_DEL:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}

// Activation/désactivation d'un parc
export function SetEnableParcReducer(state = initialStateNext, action) {
    switch (action.type) {
        case PARC_ENABLE:
            return {
                alert: action.payload.alert,
                isNext: action.payload.isNext
            }
        default:
            return state;
    }
}